import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { TEAMS_READERS } from '../auth/roles.ts'
import { guardRoute } from '../auth/guard.ts'
import { numericIdParam } from './params.ts'
import { rootRoute } from './root.tsx'

// The role lets in, as for the squad's own page; whether this squad is the caller's to change the
// page asks (`canEditRoster`) and the API answers, as the squad's kits do.
export const teamEditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/teams/$teamId/edit',
  params: numericIdParam('teamId'),
  beforeLoad: ({ context, location }) =>
    guardRoute({
      queryClient: context.queryClient,
      requiredRoles: TEAMS_READERS,
      currentPath: location.href,
    }),
  staticData: { opensOnHero: true },
  component: lazyRouteComponent(() => import('../pages/team-edit.tsx')),
})

/** The way in from the squad's head, which names the squad. */
export function teamEditLink(teamId: number) {
  return { to: '/teams/$teamId/edit', params: { teamId } } as const
}
